import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Predicate, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { Browser, enableRipple, isNullOrUndefined } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  DataStateChangeEventArgs, IFilter, PageService, PdfExportService, SearchSettingsModel, SelectionSettingsModel, SortService, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { MysqlService } from './../../../../services/mysql.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { Brand } from 'src/app/api/brand';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DataService } from 'src/app/admin/system-log-manager/data.service';


// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';


// Set Syncfuion Culture and Internationalization
import { Internationalization } from '@syncfusion/ej2-base';
import {setCulture} from '@syncfusion/ej2-base';
// setCulture('au');
import { setCurrencyCode} from '@syncfusion/ej2-base';
import { RuleModel, QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { SearchSubject } from 'src/app/shared/models/searchSubject.model';
setCurrencyCode('AUD');
import { projectData, sampleData } from 'src/app/components/grid/jobs-grid/jsontreegredidata';
import { CategoryService, ChartComponent, ColumnSeriesService, IPointEventArgs, LineSeriesService, StackingColumnSeriesService } from '@syncfusion/ej2-angular-charts';

import { Chart, LineSeries, DateTime, Legend, Tooltip, ILoadedEventArgs, ChartTheme,Category, ColumnSeries, } from '@syncfusion/ej2-charts';
import { DateTimeService, AreaSeriesService } from '@syncfusion/ej2-angular-charts'
import { LegendService, ZoomService } from '@syncfusion/ej2-angular-charts'
// import { Browser } from '@syncfusion/ej2-base';


interface Data {
  group: {
    x: string;
  };
  [key: string]: any; // Handles dynamic y fields
}

// interface ChartData {
//   label: string;
//   value: number;
// }



interface OriginalData {
  group: {
    x: string; // User name or identifier
  };
  [key: string]: any; // Handles dynamic y fields
}

interface ChartData {
  user: any;
  [key: string]: number | null; // Dynamic y fields
}




@Component({
  selector: 'app-metric-chart-multi-series-staff-all',
  templateUrl: './metric-chart-multi-series-staff-all.component.html',
  styleUrls: ['./metric-chart-multi-series-staff-all.component.scss'],
  
  providers: [ToolbarService, PdfExportService, PageService, FilterService, SortService, DataService, AreaSeriesService, LegendService, ZoomService, CategoryService, ColumnSeriesService, StackingColumnSeriesService, LineSeriesService],

  standalone: false,
})
export class MetricChartMultiSeriesStaffAllComponent implements OnInit {

  loading = true;

  //component initialization
  @ViewChild('chart')
  public chart: Chart;

     // setup as observable?
     @Input() item_id?: any; // impliments on changes.
     @Input() item_data? // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full


     // chart 
     public primaryXAxis: Object;
     public primaryYAxis: Object;
     public title: string;
     public data: any[];
     public dynamicSeries: any[]; // Array to hold dynamically created series
  tooltip: { enable: boolean; format: string; shared: boolean; };
  primaryXAxis2: { interval: number; };
  primaryYAxis2: { title: string; };
  title2: string;
   
     // Sample original data structure
    //  public item_data: any[] = [ /* Your provided data */ ];
    public zoom?: Object;
    public animation?: Object;
    public legend?: Object;

    public marker1: Object = {
      visible: true,
      width: 25,
      height: 25,
      shape: 'Diamond',
      fill: '#fff',
      opacity: 0.2,
  };


  
  public marker2: Object = {
    visible: true,
    width: 5,
    height: 5,
    shape: 'Star',
    fill: '#fff',
    opacity: 0.2,
};


public marker3: Object = {
  visible: true,
  width: 5,
  height: 5,
  shape: 'Square',
  fill: '#fff',
  opacity: 0.2,
};


public marker3_large: Object = {
  visible: true,
  width: 28,
  height: 28,
  shape: 'Square',
  fill: '#FFF',
  opacity: 0.8,
};



public marker4: Object = {
  visible: true,
  width: 5,
  height: 5,
  shape: 'Triangle',
  fill: '#fff',
  opacity: 0.2,
};


  public marker_score = { visible: true, width: 10, height: 10, shape: 'Star' };
  lineData;
  lineData2;
  lineData3;
  lineData4;
  lineData_totals: any;
  
//   lineData: Object[] = [
//     { x: 'Neil_Sharman', y: 28 }, 
//     { x: 'Systems_Administrator', y: 101 },
//     // { x: 2007, y: 26 }, 
//     // { x: 2008, y: 27 },
//     // { x: 2009, y: 32 }, 
//     // { x: 2010, y: 35 }, 
//     // { x: 2011, y: 30 }
// ];


  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,
   public gfunc: GlobalFunctionsService,
   private modalService: BsModalService,
   public toastr: HotToastService,
   vcr: ViewContainerRef,
   private _mysqlService: MysqlService,

  ) {


    // this.data = null;
    // this.dynamicSeries = [];


   }

  ngOnInit(): void {

    // this.chart.refresh();







    
  // Sample data from your original model
    // this.data = [
    //   { group: { x: 'Systems_Administrator' }, y1: { count: 43 }, y2: { count: 39 } },
    //   { group: { x: 'Network_Administrator' }, y1: { count: 25 } } // y2 is missing for this user
    // ];


 


  }


  ngOnChanges(changes: SimpleChanges) {
    this.loading = true; // Begin loading state
    this.data = null;
    this.dynamicSeries = [];
    this.lineData = []; // Clear previous lineData
    this.lineData2 = []; // Clear previous lineData
    this.lineData3 = []; // Clear previous lineData

    if (changes.item_data) {
        this.item_data = changes.item_data.currentValue;

        // Transform item_data for main chart series
        this.data = this.item_data.map(item => {
            const newItem: any = { group: item.name };
            item.user_logs_array.forEach(log => {
                // Only add valid logs and associate the log type color and icon
                if (log.log_type_name && log.count !== undefined && log.count !== null) {
                    newItem[log.log_type_name] = log.count;
                    newItem[`${log.log_type_name}_color`] = log.log_type_colour; // Store color
                    newItem[`${log.log_type_name}_icon`] = log.log_type_icon; // Store icon
                }
            });
            return newItem;
        });

        // Populate dynamic series based on log types
        this.dynamicSeries = [];
        const logTypes = this.data.reduce((acc, item) => {
            Object.keys(item).forEach(key => {
                if (key !== 'group' && !acc.includes(key) && !key.endsWith('_color') && !key.endsWith('_icon')) {
                    acc.push(key);
                }
            });
            return acc;
        }, []);

        logTypes.forEach(logType => {
            // Set default values for color and icon if they are missing
            const defaultColor = '#808080'; // Default grey color
            const defaultIcon = 'fa fa-circle'; // Default icon
            const color = this.data.find(item => item[`${logType}_color`])?.[`${logType}_color`] || defaultColor;
            const icon = this.data.find(item => item[`${logType}_icon`])?.[`${logType}_icon`] || defaultIcon;

            this.dynamicSeries.push({
                type: 'StackingColumn',
                xName: 'group',
                yName: logType,
                name: logType,
                fill: color,  // Assign color for chart and legend
                marker: {      // Set marker configuration
                    visible: true,
                    shape: 'Circle', // Shape as needed
                    width: 10,
                    height: 10,
                    dataLabel: {
                        visible: true,
                        template: `<span class="fa ${icon}" style="color:${color}; font-size: 16px;"></span>`
                    }
                }
            });
        });



              // // Step 1: Create count-per-user column series
              // const countSeries = {
              //   type: 'Column',
              //   name: 'Total Logs',
              //   xName: 'group',
              //   yName: 'total_logs',
              //   dataSource: this.item_data.map(item => ({
              //     group: item.name,
              //     total_logs: item.user_logs_array.reduce((sum, log) => sum + (log.count || 0), 0)
              //   })),
              //   fill: '#FFA500',
              //   dataLabel: {
              //     visible: true,
              //     position: 'Top',
              //     font: {
              //       fontWeight: '600',
              //       color: '#000'
              //     }
              //   }
              // };

              // // Step 2: Push this to dynamicSeries
              // this.dynamicSeries.push(countSeries);



        // Populate lineData with score differences for each user
        this.lineData_totals = this.item_data
            .map(item => ({
                x: item.name,
                y: item.count ?? 0, // Fallback to 0 if missing
                color: item.user_colour,
                icon: item.user_icon
            }))
            .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

        // Handle cases where lineData is empty by providing a placeholder
        if (this.lineData.length === 0) {
            this.lineData = [{ x: 'No Data', y: 0 }];
        }





        // Populate lineData with score differences for each user
        this.lineData = this.item_data
            .map(item => ({
                x: item.name,
                y: item.score_difference_duration ?? 0, // Fallback to 0 if missing
                color: item.user_colour,
                icon: item.user_icon
            }))
            .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

        // Handle cases where lineData is empty by providing a placeholder
        if (this.lineData.length === 0) {
            this.lineData = [{ x: 'No Data', y: 0 }];
        }



        // Populate lineData with score differences for each user
        this.lineData2 = this.item_data
            .map(item => ({
                x: item.name,
                y: item.difference_duration ?? 0, // Fallback to 0 if missing
                color: item.user_colour,
                icon: item.user_icon
            }))
            .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

        // Handle cases where lineData is empty by providing a placeholder
        if (this.lineData2.length === 0) {
            this.lineData2 = [{ x: 'No Data', y: 0 }];
        }



        // Productivity Rating
        this.lineData3 = this.item_data
        .map(item => ({
            x: item.name,
            y: item.rating_duration ?? 0, // Fallback to 0 if missing
            color: item.user_colour,
            icon: item.user_icon
        }))
        .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

    // Handle cases where lineData is empty by providing a placeholder
    if (this.lineData3.length === 0) {
        this.lineData3 = [{ x: 'No Data', y: 0 }];
    }



        // Benchmarks
        this.lineData4 = this.item_data
        .map(item => ({
            x: item.name,
            y: item.benchmark_duration ?? 0, // Fallback to 0 if missing
            color: item.user_colour,
            icon: item.user_icon
        }))
        .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

    // Handle cases where lineData is empty by providing a placeholder
    if (this.lineData4.length === 0) {
        this.lineData4 = [{ x: 'No Data', y: 0 }];
    }




        // Set chart properties
        this.primaryXAxis = {
            title: 'Activities + In-App Productivity',
            valueType: 'Category'
        };

        this.primaryYAxis = {
            title: 'Tasks',
        
        };

        this.title = 'User Activity with Benchmarking + Scores';

        // Tooltip configuration
        this.tooltip = {
            enable: true,
            format: '${point.x} : ${point.y} <br> ',
            shared: false,
        };


        this.zoom = {
          enableSelectionZooming: true,
          enablePan: true,
            mode: 'XY',
            enableAnimation: false
      };
      this.animation = { enable: false};
      this.legend = { visible: true };

        // Refresh chart if necessary
        if (this.chart) {
            // this.chart.refresh(); // Force refresh in case of missing or updated data
        }

        // End loading state after data processing and chart refresh
        this.loading = false;
    }
}




}
